import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
import formatDateTime, { formatDate } from "../../../../utils/dateFormatter";
import { GetPaymentReceiveById } from "../../../../api/ipd/paymentReceiveAPI";
import { numberToWords } from "../../../../utils/amountFormatter";

const IpdPaymentReceiveReceipt = () => {
  const { id } = useParams();
  const [paymentReceive, setPaymentReceive] = useState(null);
  const printRef = useRef();

  useEffect(() => {
    fetchIpdPaymentReceiveReceipt();
  }, []);

  const fetchIpdPaymentReceiveReceipt = async () => {
    const res = await GetPaymentReceiveById(id);
    if (res.success) {
      setPaymentReceive(res.data);
    }
  };

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open("", "", "height=600");

    printWindow.document.write(`
      <html>
        <head>
          <title>IPD Registration Receipt</title>
          <style>
            @page { margin: 1cm; }
            body {
              margin: 1cm;
              font-family: Arial, sans-serif;
              font-size: 14px;
            }
            table { width: 100%; }
          </style>
        </head>
        <body>
          ${printContents}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            }
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  if (!paymentReceive) return <p>Loading...</p>;

  const advance = paymentReceive.advance || 0;

  return (
    <>
      {/* ACTION BUTTONS */}
      <div style={{ textAlign: "right", marginTop: "100px", marginBottom: "15px" }}>
        <button
          id="print"
          className="btn btn-info me-2"
          onClick={handlePrint}
        >
          <i className="fa fa-print" /> Print Receipt
        </button>
        <UncontrolledTooltip target="print">
          Print Payment Receive Receipt
        </UncontrolledTooltip>

        <Link to="/ipd/transaction/ipd-entry/list">
          <button className="btn btn-primary" id="list">
            Payment Receive Entry List
          </button>
          <UncontrolledTooltip target="list">
            Payment Receive Entry List
          </UncontrolledTooltip>
        </Link>
      </div>

      {/* RECEIPT */}
      <div
        ref={printRef}
        style={{
          width: "90%",
          margin: "auto",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px"
        }}
      >
        {/* HEADER */}
        <table width="100%" style={{ borderCollapse: "collapse" }}>
          <tbody>
            <tr>
              {/* 1. Logo Cell */}
              <td width="10%" style={{ textAlign: "right" }}>
                <img
                  src="/logo.png"
                  alt="logo"
                  style={{ width: "150px" }}
                />
              </td>

              {/* 2. Perfectly Centered Text */}
              <td style={{ textAlign: "center" }}>
                <h2 style={{ margin: 0 }}>DR. PERWEZ HOSPITAL</h2>
                <div>DR. A. RAHMAN CAMPUS, CHHATAUNI ROAD, MOTIHARI</div>
                <div>(M.J. HEART HOSPITAL & RESEARCH INSTITUTE)</div>
                <strong>PAYMENT RECEIVE RECEIPT</strong>
              </td>

              {/* 3. Buffer Cell (Same width as logo cell to balance the center) */}
              <td width="10%"></td>
            </tr>
          </tbody>
        </table>

        <br />

        {/* BASIC INFO */}
        <table width="100%">
          <tbody>
            <tr>
              <td width="50%">
                <strong>Receipt No.:</strong> {paymentReceive.receiptNo}
              </td>
              <td width="50%" style={{ textAlign: "right" }}>
                <strong>Date:</strong>{" "}
                {formatDate(paymentReceive.date)}
              </td>
            </tr>

            <tr>
              <td>
                <strong>Receive With Thanks From:</strong>{" "}
                {paymentReceive.ipdEntryId?.patientId?.patientNamePrefix} {paymentReceive.ipdEntryId?.patientId?.patientName}
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>UHID No.:</strong>{" "}
                {paymentReceive.ipdEntryId?.patientId?.uhidNo}
              </td>
            </tr>

            <tr>
              <td>
                <strong>Consultant Name:</strong>{" "}
                {paymentReceive.ipdEntryId?.consultantDoctorId?.name}
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>Age / Sex:</strong>{" "}
                {paymentReceive.ipdEntryId?.patientId?.age} {paymentReceive.ipdEntryId?.patientId?.ageSuffix} / {paymentReceive.patientId?.sex}
              </td>
            </tr>

            <tr>
              <td>
                <strong>Payment Mode.:</strong> {paymentReceive.paymentMode}
              </td>
              <td style={{ textAlign: "right" }}>
                {
                  paymentReceive.type === "IPD" &&
                  <>
                    <strong>IPD No.:</strong> {paymentReceive.ipdEntryId?.ipdNo || "-"}
                  </>
                }
                {
                  paymentReceive.type === "Discharge" &&
                  <>
                    <strong>IPD No.:</strong> {paymentReceive.ipdEntryId?.ipdNo || "-"}
                  </>
                }
                {
                  paymentReceive.type === "Investigation" &&
                  <>
                    <strong>Lab No.:</strong> {paymentReceive.labRegistrationId?.labNo || "-"}
                  </>
                }
              </td>
            </tr>

            <tr>
              <td>
                <strong>Paid Amount:</strong>{" "}
                Rs. {numberToWords(paymentReceive.amount)} Only
              </td>
              <td style={{ textAlign: "right" }}>
                
              </td>
            </tr>
          </tbody>
        </table>

        <hr />

        {/* PAYMENT INFO */}
        <table width="100%">
          <tbody>
            <tr>
              <td width={"10%"} style={{ textAlign: "center" }}>
                <div style={{ border: "1px solid black",padding:"8px" }}>
                <strong>Rs.:</strong>
                </div>
              </td>
              <td width={"10%"} style={{ textAlign: "center" }}>
                <div style={{ border: "1px solid black",padding:"8px" }}>
                {paymentReceive.amount}
                </div>
              </td>
              <td width={"80%"} style={{ textAlign: "right" }}>
                
              </td>
            </tr>
          </tbody>
        </table>

        <br />

        {/* FOOTER */}
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <strong>Prepared By:</strong> Admin
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>Authorized Signatory</strong>
              </td>
            </tr>
          </tbody>
        </table>

        <hr />

        <p style={{ textAlign: "end", fontSize: "12px" }}>
          Printed On: {formatDateTime(new Date())}
        </p>
        <p style={{ textAlign: "end", fontSize: "12px" }}>
          Not Valid For Medicolegal Purposes
        </p>
      </div>
    </>
  );
};

export default IpdPaymentReceiveReceipt;
